import { fetchRequestWithTypes } from './index.js';

export const GET_INSTITUTION_REQUEST = 'GET_INSTITUTION_REQUEST';
export const GET_INSTITUTION_SUCCESS = 'GET_INSTITUTION_SUCCESS';
export const GET_INSTITUTION_ERRORED = 'GET_INSTITUTION_ERRORED';

export const getInstitution = (institution_id) =>
	fetchRequestWithTypes({
		types: [GET_INSTITUTION_REQUEST, GET_INSTITUTION_SUCCESS, GET_INSTITUTION_ERRORED],
		request: {
			method: 'GET',
			path: `/institutions_search/institutions/${institution_id}`,
		},
	});

export const SEARCH_INSTITUTIONS_REQUEST = 'SEARCH_INSTITUTIONS_REQUEST';
export const SEARCH_INSTITUTIONS_SUCCESS = 'SEARCH_INSTITUTIONS_SUCCESS';
export const SEARCH_INSTITUTIONS_ERRORED = 'SEARCH_INSTITUTIONS_ERRORED';

export const searchInstitutions = (name = '', limit = 10) =>
	fetchRequestWithTypes({
		types: [
			SEARCH_INSTITUTIONS_REQUEST,
			SEARCH_INSTITUTIONS_SUCCESS,
			SEARCH_INSTITUTIONS_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/institutions_search/institutions?name=${name}&limit=${limit}`,
		},
	});
